import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type {
  ImportWorkOrderFileMutation,
  ImportFileInput,
  ImportFileOutputData,
} from '#/graphql/types';
import { importWorkOrderFile } from '#/graphql/mutations';

const q = gql(importWorkOrderFile);

const useImportWorkOrderFileMutation = () => {
  const [mutation, result] = useMutation<ImportWorkOrderFileMutation>(q);
  const importWorkOrderFile = useCallback(
    async (data: ImportFileInput): Promise<ImportFileOutputData | null> => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.importWorkOrderFile', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Import failed';
        throw new Error(errorMessage);
      }

      return get(response, 'data.importWorkOrderFile.data', null);
    },
    [mutation],
  );

  return { importWorkOrderFile, result };
};

export default useImportWorkOrderFileMutation;
